import { render } from "./postnotice.vue?vue&type=template&id=5c01f3d2"
import script from "./postnotice.vue?vue&type=script&lang=js"
export * from "./postnotice.vue?vue&type=script&lang=js"

import exportComponent from "/home/metabrain/withyou/djvue/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__